import React from 'react';
import 'twin.macro';

interface Props {
  className?: string;
}

export function BreakBeforePageDivider(props: Props) {
  return (
    <div
      className={props.className}
      tw="w-full print:hidden border-t-2 border-dashed border-neutral-quiet"
    />
  );
}
